import {
  Box,
  Button,
  createStyles,
  Theme,
  Typography,
  withStyles,
  Chip,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import managerClassApi from "api/managerClass";
import {useAppDispatch, useAppSelector} from "app/hooks";
import {useConfirm} from "material-ui-confirm";
import {ResponseStatus} from "models/common";
import {IClass} from "models/managerClass";
import React, {Fragment, useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import {
  fetchClassList,
  selectClassList,
  selectFilterClassList,
  selectPageInfoClass,
  setFilterClass,
} from "../../managerClassSlice";
import EditClass from "../EditClass";
import DetailClassModal from "../DetailClassModal";
import useStyles from "./style";
import EmptyComponent from "components/Empty";
import {useSelector} from "react-redux";
import {Pagination} from "@material-ui/lab";

export default function TableClass() {
  const StyledTableCell = withStyles((theme: Theme) =>
    createStyles({
      head: {
        padding: "14px 16px",
        backgroundColor: "#F8FAFC",
        color: "#0F172A",
        fontSize: 12,
        fontWeight: 700,
        borderRight: "1px solid #F1F5F9",
        borderBottom: "2px solid #E2E8F0",
        top: "0 !important",
        [theme.breakpoints?.up("xl")]: {
          fontSize: 14,
        },
      },
      body: {
        padding: "12px 16px",
        fontSize: 12,
        borderRight: "1px solid #F1F5F9",
        borderBottom: "1px solid #F1F5F9",
        fontWeight: 500,
        color: "#334155",
        [theme.breakpoints?.up("xl")]: {
          fontSize: 13,
        },
      },
    })
  )(TableCell);
  const dispatch = useAppDispatch();
  const {t} = useTranslation();
  const [openModal, setOpenModal] = useState(false);
  const [openDetailModal, setOpenDetailModal] = useState(false);
  const [selectedClassDetail, setSelectedClassDetail] = useState<IClass | null>(null);
  const classList = useAppSelector(selectClassList);
  const filterClassList = useSelector(selectFilterClassList);
  const pageInfo = useSelector(selectPageInfoClass);
  const classes = useStyles();
  const confirm = useConfirm();

  const [valueClass, setValueClass] = useState<IClass>({
    name: "",
    description: "",
    id: 0,
  });

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const targetParents: HTMLElement[] = [];
    const originalOverflows: string[] = [];

    if (containerRef.current) {
      let parent = containerRef.current.parentElement;
      while (parent && parent.tagName !== "MAIN") {
        const computedStyle = window.getComputedStyle(parent);
        if (
          computedStyle.overflow === "hidden" ||
          computedStyle.overflowX === "hidden" ||
          computedStyle.overflowY === "hidden"
        ) {
          targetParents.push(parent);
          originalOverflows.push(parent.style.overflow);
          parent.style.overflow = "visible";
        }
        parent = parent.parentElement;
      }
    }

    return () => {
      targetParents.forEach((parent, index) => {
        if (parent) {
          parent.style.overflow = originalOverflows[index];
        }
      });
    };
  }, [classList]);
  useEffect(() => {
    dispatch(fetchClassList(filterClassList));
  }, [dispatch, filterClassList]);

  const handleOpenDetail = (item: IClass) => {
    setSelectedClassDetail(item);
    setOpenDetailModal(true);
  };

  const handleDeleteClass = (e: React.MouseEvent, item: IClass) => {
    e.stopPropagation();
    confirm({
      title: (
        <Typography variant="h5" color="secondary">
          {t("delete.chuy")}
        </Typography>
      ),
      description: (
        <Typography variant="subtitle2">
          {t("delete.khiban")}{" "}
          <Typography variant="subtitle2" component="span" color="secondary">
            {t("delete.dongy")}
          </Typography>{" "}
          {t("delete.xoa")}
          <Typography variant="subtitle2" component="span" style={{color: "#004673"}}>
            {" "}
            {item.name}
          </Typography>{" "}
          {t("delete.sexoatatcadulieu")}
        </Typography>
      ),
      confirmationText: <Button className={classes.btn_delete}> {t("delete.dongy")}</Button>,
      cancellationText: (
        <Button className={classes.btn_edit} style={{marginRight: 0}}>
          {t("delete.huybo")}
        </Button>
      ),
    })
      .then(async () => {
        const res: ResponseStatus = await managerClassApi.deleteClass(item.id);
        if (res.responseCode === "00") {
          toast.success(`${t("managerClass.xoaclassthanhcong")}`);
          dispatch(fetchClassList(filterClassList));
        } else {
          if (res.responseCode === "30") {
            toast.error(`${t("managerClass.xoaclassthatbai")}`);
            throw new Error("Delete class is failed");
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleEditClass = (e: React.MouseEvent, value: IClass) => {
    e.stopPropagation();
    setOpenModal(true);
    setValueClass(value);
  };

  const handleChangePage = (page: number) => {
    dispatch(
      setFilterClass({
        ...filterClassList,
        page: page - 1,
      })
    );
  };
  return (
    <div ref={containerRef}>
      <Fragment>
        <Box>
          {classList.length > 0 ? (
            <>
              <TableContainer component={Paper} className={classes.container}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center" width="130px">
                      {t("stt")}
                    </StyledTableCell>
                    <StyledTableCell align="center">{t("managerClass.tenclass")}</StyledTableCell>
                    <StyledTableCell align="center">{t("managerClass.mota")}</StyledTableCell>
                    <StyledTableCell align="center" width="170px">
                      {t("managerClass.soluong")}
                    </StyledTableCell>
                    <StyledTableCell align="center" width="300px">
                      {t("thaotac")}
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {classList.map((item: IClass, index: number) => (
                    <TableRow 
                      key={item.id} 
                      hover 
                      onClick={() => handleOpenDetail(item)}
                      style={{ cursor: "pointer" }}
                    >
                      <StyledTableCell align="center" component="th" scope="row">
                        <Typography style={{ fontWeight: 700, color: "#334155", fontSize: "0.875rem" }}>
                          {pageInfo.pageSize * pageInfo.pageIndex + index + 1}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <Typography style={{ fontWeight: 700, color: "#0F172A", fontSize: "0.875rem" }}>
                          {item.name}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell align="center">{item.description || "---"}</StyledTableCell>
                      <StyledTableCell align="center">
                        <Chip
                          label={`${item.numberStudents || 0} học viên`}
                          size="small"
                          style={{
                            backgroundColor: "#EEF2FF",
                            color: "#4F46E5",
                            fontWeight: 700,
                            borderRadius: 8,
                            padding: "2px 4px",
                          }}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <Button className={classes.btn_edit} onClick={(e) => handleEditClass(e, item)}>
                          {t("button.edit")}
                        </Button>
                        <Button
                          className={classes.btn_delete}
                          onClick={(e) => handleDeleteClass(e, item)}
                        >
                          {t("button.delete")}
                        </Button>
                      </StyledTableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Mobile View: ListView */}
            {isMobile && (
              <Box className={classes.mobileListView}>
                {classList.map((item: IClass, index: number) => (
                  <Box 
                    key={item.id} 
                    className={classes.mobileCard}
                    onClick={() => handleOpenDetail(item)}
                    style={{ cursor: "pointer" }}
                  >
                    {/* Card Header: Title & Index */}
                    <Box className={classes.mobileCardHeader}>
                      <Box>
                        <Typography variant="subtitle2" style={{ fontWeight: 800, color: "#0F172A" }}>
                          {item.name}
                        </Typography>
                        <Typography variant="caption" style={{ color: "#64748B" }}>
                          STT: {pageInfo.pageSize * pageInfo.pageIndex + index + 1}
                        </Typography>
                      </Box>
                    </Box>

                    {/* Card Body: Info rows */}
                    <Box className={classes.mobileCardBody}>
                      <Box className={classes.mobileCardRow}>
                        <Typography variant="caption" style={{ color: "#64748B", fontWeight: 700 }}>
                          SỐ LƯỢNG HỌC VIÊN
                        </Typography>
                        <Chip
                          label={item.numberStudents || 0}
                          size="small"
                          style={{
                            backgroundColor: "#EEF2FF",
                            color: "#4F46E5",
                            fontWeight: 700,
                            borderRadius: 6,
                          }}
                        />
                      </Box>

                      <Box className={classes.mobileCardRow}>
                        <Typography variant="caption" style={{ color: "#64748B", fontWeight: 700 }}>
                          MÔ TẢ LỚP HỌC
                        </Typography>
                        <Typography variant="caption" style={{ fontWeight: 600, color: "#334155" }}>
                          {item.description || "---"}
                        </Typography>
                      </Box>
                    </Box>

                    {/* Card Actions */}
                    <Box className={classes.mobileCardActions}>
                      <Button
                        className={classes.btn_edit}
                        style={{ margin: 0 }}
                        onClick={(e) => handleEditClass(e, item)}
                      >
                        Sửa
                      </Button>
                      <Button
                        className={classes.btn_delete}
                        style={{ margin: 0 }}
                        onClick={(e) => handleDeleteClass(e, item)}
                      >
                        Xóa
                      </Button>
                    </Box>
                  </Box>
                ))}
              </Box>
            )}
          </>
        ) : (
          <EmptyComponent />
        )}
      </Box>

      {pageInfo?.totalPages > 1 && (
        <Box className={classes.paginationContainer}>
          <Typography variant="subtitle2" style={{fontWeight: 600}}>
            {"Tổng lớp học"}: {pageInfo.totalElements}
          </Typography>
          <Pagination
            count={Math.ceil(pageInfo?.totalElements / pageInfo?.pageSize)}
            page={pageInfo?.pageIndex + 1}
            variant="outlined"
            color="primary"
            shape="rounded"
            size={isMobile ? "small" : "medium"}
            siblingCount={isMobile ? 0 : 1}
            onChange={(e, page) => handleChangePage(page)}
          />
        </Box>
      )}

      <EditClass
        valueClass={valueClass}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />

      <DetailClassModal
        open={openDetailModal}
        classId={selectedClassDetail?.id || null}
        classNameText={selectedClassDetail?.name || ""}
        handleClose={() => setOpenDetailModal(false)}
      />
      </Fragment>
    </div>
  );
}
